import React from 'react';
import { EmptyState, type EmptyStateAction } from '../../components/EmptyState';

interface EmptyPageProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  /** The way out — every dead end should offer one. */
  action?: EmptyStateAction;
  /** Quieter follow-up, e.g. a reference to quote to support. */
  secondary?: React.ReactNode;
}

/**
 * A whole screen that has nothing to show — not found, failed to load, or
 * nothing configured yet.
 *
 * It was a 96px grey icon over two lines of grey text with no way forward;
 * "Something went wrong. Please try again later." leaves someone with nothing
 * to press. It is the shared empty-state template now, so a dead end looks the
 * same wherever it happens and always offers a door.
 */
const EmptyPage: React.FC<EmptyPageProps> = ({ icon, title, description, action, secondary }) => (
  <div className="flex min-h-[70vh] items-center justify-center bg-surface px-6">
    <EmptyState
      icon={icon}
      title={title}
      description={description}
      action={action}
      secondary={secondary}
      testId="empty-page"
    />
  </div>
);

export default EmptyPage;
